
var brillia_selected_subscribe = false;
var brillia_selected_subscribe_initialvar = false;
var brillia_resume_purchase_behavior = false;

$(function() {
  
 	BOLD.common.eventEmitter.enableLog();
   
	if(window.BOLD && window.BOLD.common && window.BOLD.common.eventEmitter && window.BOLD.recurring_orders){
    

    // format dosage buttons  
    $('fieldset[data-index="option2"] div label.variant__button-label').each(function( index ) {
      lbl = $(this).html();
      $(this).html(lbl.replace(" (", "<span class='doselbl'>").replace(")", "</span>"));
    });
      
	// add step numbers to dosage and supply
    $('.variant-wrapper > label:contains("Choose your supply")').addClass('step1');
    $('.variant-wrapper > label:contains("Choose your dosage")').addClass('step2');
   // $('.variant-input-wrap[data-index="option2"]').prepend("<div  class='brillia-dosage-note'>*Moderate is recommended if you're not sure about the severity to choose. You can adjust the dosage every cycle as needed.</div")

	// hide mild option
    $('.variant-input.single-option[data-value *="Mild Symptoms"]').css('display','none');
      
    // add title to purchase options  
    $('.bold-ro__recurring-title').html('03. Purchase Options');
    
    // event listener for brillia faux frequency buttons - consider removing, as not used
    $(document).on('click', '.brillia_btn', function(){ 
        $('.brillia_btn').removeClass('active');
        $(this).addClass('active');
        if($(this).data('value') == '3'){
        	$('div.brillia-freq').text('My child benefits from continual use of Brillia so I do not want to skip the 4th month.');
        }
        if($(this).data('value') == '4'){
         	$('div.brillia-freq').text('My child benefits from skipping every 4th month of Brillia. I want to receive my bundle every 4th month.');
        }
        brillia_freq_expand();
        $('select.bold-ro__frequency-num').val($(this).data('value')).trigger('change');
    }); 

  // set height of freq container - consider removing, not used in current form
  function brillia_freq_expand(){ 
      if($('.bold-ro__frequency-div').length > 0){
        //$('.bold-ro__frequency-div').height($('.bold-ro__frequency-label').height()+50);
        //$('.bold-ro__frequency-div').height($('.bold-ro__frequency-label').height());
      }
   		// $('.ro_widget').css('margin-bottom',$('.bold-ro__frequency-label').height()+80 );
     	// $('.ro_widget').css('margin-bottom',$('.bold-ro__frequency-label').height() );
  }
      

  // consider removing not used since freq is hidden
  function brillia_freq_collapse(){ 
    $('.bold-ro__frequency-div').height(0);
    $('.ro_widget').css('margin-bottom',0);
  }
  
  
  
  
  
  

  function brillia_updatePricing(){

        var compare_price;
        var actual_price;
        var sub_actual_price;
        var sub_actual_price_noformat;
        var discount;
        var current_variants = $.parseJSON( $('div[id^="VariantsJson"]').text() );
        //alert(current_variant[0].id);
    
    	// get prices from json object
        var selectedvariant = $('select.product-single__variants').val();
        $.each( current_variants, function( key, value ) {
          if(selectedvariant == this.id){
            compare_price = (parseFloat(this.compare_at_price)/100).toFixed(2);
            actual_price = (parseFloat(this.price)/100).toFixed(2);
          }
        });



    if($('.bold-ro__radio-div.bold-ro__recurring-div.bold-ro__sub.bold-ro__bold-active').length > 0){
      // subscription is clicked
      sub_actual_price = $('input.bold-ro__discounted-price').val();
      sub_actual_price_noformat = parseFloat($('input.bold-ro__unformatted-price').val())/100;
      discount = Math.round(((compare_price-sub_actual_price_noformat)/compare_price)*100);

      // is product on sale?
      if($('.product__price.on-sale').length > 0){
        //on sale
        $('.product__price.on-sale').text(sub_actual_price);   
        $('.product__price-savings').text('Save '+discount+'%');
      }else{
        // not on sale
        // insert faux discount
        $('.product__price').text(sub_actual_price);   
        discount = Math.round(((actual_price-sub_actual_price_noformat)/actual_price)*100);
        if($('.brillia_sub_price').length >0 ){}else{
          $('.product__price').prepend('<span class="brillia_sub_price">$'+actual_price+'</span>');
          $('.product__price').append('<span class="brillia_sub_price_discount">Save '+discount+'%</span>');
          $('.brillia_sub_price_discount').append('<span class="brillia_sub_price_ship">(with free shipping)</span>');
        }
      }
    } else{

      // one time is clicked
      // is product on sale?
      if($('.product__price.on-sale').length > 0){
        //on sale
        $('.product__price.product__price--compare').text('$'+compare_price);
        $('.product__price.on-sale').text('$'+actual_price);
        discount = Math.round(((compare_price-actual_price)/compare_price)*100);
        $('.product__price-savings').text('Save '+discount+'%');

      }else{
        // not on sale
         $('.product__price').text('$'+actual_price);
      }

    }
  }

  
  
  // check if varient is set, consider removing not currently used  
   function getUrlVars() {
      var vars = {};
      var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
          vars[key] = value;
      });
      return vars;
  }

  
    
//CLICKED OE TIME PRODUCT
    BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_one_time_product_selected",function(e){
      //alert('one_time_product_selected');
     // BOLD.common.preselect_subscribe_recurring_orders_widget(e.data.form);
      
      	brillia_updatePricing();
      $('.brillia_post_form_content p').html('100% Money Back Guarantee');
      	// remove as frequency is being removed
        //brillia_freq_collapse();
    });
    
  
//CLICKED RECURRING ORDER
    BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_mixed_product_recurring",function(e){
     // alert('mixed_product_recurring');
     // BOLD.common.preselect_subscribe_recurring_orders_widget(e.data.form);
      
           
      // remove unavailable frquencies
      $('select.bold-ro__frequency-num option[value=4]').remove();
      $('select.bold-ro__frequency-num option[value=2]').remove();
      $('select.bold-ro__frequency-num option[value=1]').remove();
      // add brillia buttons
      if($('div.brillia_btn').length == 0){
      	//$('.bold-ro__order-interval-container').prepend('<div class="brillia-freq">My child benefits from continual use of Brillia so I do not want to skip the 4th month.</div><div class="brillia_btn active" data-value=3>Receive Every 3 Months</div><div class="brillia_btn" data-value=4>Receive Every 4 Months</div>');
     	//$('.bold-ro__order-interval-container').prepend('<div class="brillia-freq">My child benefits from continual use of Brillia so I do not want to skip the 4th month.</div><div class="brillia_btn active" data-value=3>Receive Every 3 Months</div>');
      }
      $('.bold-ro__frequency-label span.bold-ro__fixed-frequency-text').addClass('brillia_btn').addClass('active');
      //brillia_freq_expand();
      brillia_updatePricing();
      $('.brillia_post_form_content p').html('100% Money Back Guarantee<br>Cancel Anytime<br>No Surprises, we notify you before each renewal');
      // change text of one month frequency
      //if($('span.bold-ro__fixed-frequency-text').length > 0){
        //$('span.bold-ro__fixed-frequency-text').text('Receive Every Month');
      //}
    });
    
    

    
// CHANGED VARIENT
    BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_variant_changed",function(e){

      brillia_updatePricing();
    
    });
    

    
 
    //single and multiple product event emitter listener
    BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_widget_loaded",function(e){
      BOLD.common.preselect_subscribe_recurring_orders_widget(e.data.form);
      brillia_selected_subscribe = true;
      
    });
      
     
    BOLD.common.eventEmitter.on("BOLD_RECURRING_ORDERS_cart_widget_render_finished",function(e){

      if(brillia_selected_subscribe){
        //console.log("widget render finished - already selected");
      } else{
        
       // console.log("widget render finished - not selected"); 
    //recheck default to trigger subscribe default
    // get currently selected
        if(!brillia_selected_subscribe_initialvar){
          var cur_dose_selected = $('.variant-input.single-option[data-index="option2"] input[checked="checked"]');
          cur_dose_selected.prop('checked', false);
          cur_dose_selected.click().prop('checked', true);
          brillia_selected_subscribe_initialvar = true;
        }
    
        
        
        
      };
      
    });
      
      
      
 
    //function added to bold common scope, requires an element higher in hierarchy than the subscribe div
    BOLD.common.preselect_subscribe_recurring_orders_widget =  function (e){
      setTimeout(function(){
        var btn;
 
        //recurring_cart: 0, single_product: 1, mixed_cart: 2
        //if in single product or multiple product
          btn = e.querySelector('.bold-ro__subscribe-radio-btn');
        
        //if button exists, click it, if not, do nothing
        if(btn){
			if(!brillia_resume_purchase_behavior){
              btn.click();
              if(brillia_selected_subscribe_initialvar){
                brillia_resume_purchase_behavior = true;
              }
            }
        }
      }, 10);
    }

    
    
    
  }
  
});